export const isEmpty = (arr: unknown[]) => arr.every((el) => el === null) || arr.length === 0;
